import "./GameTimeModal.css";

export default function GameTimeModal({ game, onClose }) {
  if (!game) return null;

  return (
    <div
      className="gametime-overlay"
      style={{
        background: "rgba(0,0,0,0.55)",
        backdropFilter: "blur(4px)"
      }}
    >
      <div
        className="gametime-modal"
        style={{
          position: "relative",
          width: "300px",
          padding: "36px 18px 26px",
          borderRadius: "20px",
          background: "linear-gradient(180deg,#ffffff,#f6f6f6)",
          boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
          textAlign: "center"
        }}
      >
        {/* ❌ FORCE CLOSE BUTTON */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "-14px",
            right: "14px",
            width: "42px",
            height: "42px",
            borderRadius: "50%",
            background: " #fdb063",
            color: "#FFFFFF",
            fontSize: "22px",
            border: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 6px 14px rgba(0,0,0,0.25)"
          }}
        >
          ✕
        </button>

        {/* TITLE */}
        <h3
          className="main-title"
          style={{
            fontSize: "16px",
            fontWeight: "800",
            color: " #fdb063",
            marginBottom: "6px"
          }}
        >
          Bidding Is Closed For Today
        </h3>

        {/* GAME NAME */}
        <p
          className="game-name"
          style={{
            display: "inline-block",
            padding: "6px 14px",
            borderRadius: "999px",
            background: "#fff",
            fontSize: "14px",
            fontWeight: "700",
            color: "#1f2937",
            marginBottom: "18px",
            boxShadow: "0 3px 8px rgba(0,0,0,0.1)"
          }}
        >
          {game.gameName}
        </p>

        {/* TIME LIST */}
        <div
          className="time-list"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px"
          }}
        >
          {[
            ["Open Result Time", game.openTime],
            ["Open Bid Last Time", game.openTime],
            ["Close Result Time", game.closeTime],
            ["Close Bid Last Time", game.closeTime],
          ].map(([label, time], index) => (
            <p
              key={index}
              style={{
                margin: 0,
                padding: "10px 12px",
                background: "#ffffff",
                borderRadius: "12px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "12px",
                fontWeight: "600",
                color: "#4b5563",
                boxShadow: "0 3px 6px rgba(0,0,0,0.08)"
              }}
            >
              {label} :
              <span
                style={{
                  fontWeight: "800",
                  color: "#1f2937"
                }}
              >
                {time}
              </span>
            </p>
          ))}
        </div>

        {/* OK BUTTON */}
        <button
          className="gametime-ok"
          onClick={onClose}
          style={{
            marginTop: "22px",
            width: "100%",
            height: "44px",
            borderRadius: "999px",
            border: "none",
            background:
              "linear-gradient(180deg, #fdb063, #fdb063, #fdb063)",
            color: "#fff",
            fontSize: "15px",
            fontWeight: "700",
            cursor: "pointer",
            boxShadow:
              "0 4px 0 #9f7c1f, 0 10px 18px rgba(212,175,55,0.45)"
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
}
